import React, { useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";

import styled from "styled-components";

import WelcomePopupImage from "assets/png/popup/WelcomePopupImage.png";

import Button from "components/atoms/Button";
import Text from "components/atoms/text/Text";

import AbstractPopup from "components/page/popup/AbstractPopup";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: auto;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
`;

const CompleteImgWrap = styled.div`
    width: 200px;

    > img {
        width: 100%;
    }
`;

function WelcomePopupContent(props) {
    return (
        <AbstractPopup showFooter={false} onClose={props.onClose} showHeader={true}>
            <Container>
                <Wrapper>
                    <CompleteImgWrap>
                        <img src={WelcomePopupImage} alt={"회원가입 완료 이미지"} />
                    </CompleteImgWrap>
                    <Text variant="title-xl" textAlign={"center"} margin={"24px 0 0 0"} color="var(--color-Black)">
                        가입을 환영합니다!
                    </Text>
                    <Text
                        variant="sentence-lg"
                        textAlign={"center"}
                        color={"var(--color-SubBlack)"}
                        margin={"12px 0 0 0"}
                        width="fit-content"
                        height="fit-content"
                        lineHeight="1.5"
                        letterSpacing="-0.03em"
                        wordBreak="keep-all"
                    >
                        웰컴 쿠폰이 발급되었어요.
                        <br />
                        연구활동을 한단계 업그레이드해 줄 Pro 요금제를
                        <br />
                        지금부터 무료로 사용해보세요.
                    </Text>
                    <Button
                        onlyText
                        margin={"24px"}
                        width={"100px"}
                        height={"32px"}
                        fontColor={"var(--color-White)"}
                        bgColor={"var(--color-Button1)"}
                        hoverBgColor={"var(--color-ButtonHover1)"}
                        buttonText={"쿠폰 확인"}
                        onClick={(e) => {
                            props.navigate(`/${props.private_space_uuid}/management`);
                            props.onClose();
                        }}
                    />
                </Wrapper>
            </Container>
        </AbstractPopup>
    );
}

export default function openWelcomePopup(props) {
    confirmAlert({
        customUI: ({ onClose }) => <WelcomePopupContent onClose={onClose} {...props} />,
    });
}
